export default __webpack_public_path__ + "static/media/gameselect.c10f49a8.mp3";